import {rubric, ABRubric} from './components/rubric.js'
import { FaCheck, FaMinus, FaPlus } from 'react-icons/fa';

export const GRADING_DEFAULT_POINTS = 5

export const calcGrade = (feedback) => {
  if(!feedback || !feedback.rubric) {
      return null
  } else {
      let grade = applyDefaultRubric(feedback.rubric)
      return grade.points / grade.maxPoints
  }
  
}

export const calcGradeFraction = (feedback) => {
  if(!feedback || !feedback.rubric) {
      return null
  } else {
      let grade = applyDefaultRubric(feedback.rubric)
      return grade
  }
  
}

export const checkify = (nPoints, maxPoints, feedbackFormat) => {
  /**
   * Note: Chris Piech reports grades in checks. Jerry requests
   * that grades be reported in fractions. All grade reporting ends
   * in this function! So even though the name is "checkify" in reality
   * it is visualizing the grade in the instructors preferred format.
   */
  // under all systems, ungraded is blank
  if(maxPoints == 0) {
    return <></>
  }

  
  // first, lets have a case for the format being fraction
  if(feedbackFormat === 'fraction') {
    return <span>{nPoints} / {maxPoints}</span>
  }

  // and a case for percentage
  if(feedbackFormat === 'percentage') {
    return <span>{Math.round(100 * (nPoints / maxPoints))}%</span>
  }
  
  // this is the standard check system
  let rawGrade = nPoints / maxPoints
  if(rawGrade >= 0.92) {
      return <span aria-label={"check-plus"}><FaCheck /><FaPlus/></span>
  }
  if(rawGrade >= 0.8) {
      return <span aria-label={"check-plus"}><FaCheck/></span>
  }
  if(rawGrade >= 0.5) {
      return <span aria-label={"check-minus"}><FaCheck/><FaMinus/></span>
  }
  if(rawGrade > 0) {
      return <span aria-label={"minus"}><FaMinus/></span>
  }
  return <b><i>0</i></b>
}

/**
 * special checkify function for Above and Beyond grading.
 * 3=check+, 2=check, 1=check-, 0=none
 */
export const checkifyAB = (nPoints, maxPoints, feedbackFormat) => {
  if(maxPoints === 0) {
    return <></>
  }

  // fraction format
  if(feedbackFormat === 'fraction') {
    return <span>{nPoints} / {maxPoints}</span>
  }

  // percentage format
  if(feedbackFormat === 'percentage') {
    return <span>{Math.round(100 * (nPoints / maxPoints))}%</span>
  }
  
  // check format
  if (nPoints === 3) {
    return <span aria-label={"check-plus"}><FaCheck /><FaPlus/></span>
  } else if (nPoints === 2) {
    return <span aria-label={"check"}><FaCheck/></span>
  } else if (nPoints === 1) {
    return <span aria-label={"check-minus"}><FaCheck/><FaMinus/></span>
  } else {
    return <b><i>0</i></b>
  }
}

export function applyDefaultRubric(rubricValues){
    return computeGrade(rubric, rubricValues)
}

export function applyABRubric(rubricValues){
    return computeABGrade(ABRubric, rubricValues)
}

export function computeGrade(rubric, rubricValues) {
    let nDeductions = 0
    let nPoints = 0
    for (const rubricItem of rubric) {
      let value = rubricValues[rubricItem.id]
      if(value && value != "none") {
        nPoints += rubricItem.maxPoints
        for (const optionItem of rubricItem.options) {
          if(optionItem.value == value) {
            nDeductions += optionItem.points
          }
        }
      }
    }
    
    return {
      points:nPoints - nDeductions, 
      maxPoints:nPoints
    }
  }

// the original grading calculates deductions; ABGrade calculates raw points only
export function computeABGrade(rubric, rubricValues) {
  let totalPoints = 0;
  let maxPoints = 0;
  
  for (const rubricItem of rubric) {
    maxPoints += rubricItem.maxPoints;
    let value = rubricValues[rubricItem.id];
    
    if(value && value !== "none") {
      for (const optionItem of rubricItem.options) {
        if(optionItem.value === value) {
          totalPoints += optionItem.points;
          break;
        }
      }
    }
  }
  
  return {
    points: totalPoints,
    maxPoints: maxPoints
  }
}